import ValidatedOpenTicketSearch from './ValidatedOpenTicketSearch';

export default ValidatedOpenTicketSearch;
